export var DEFAULT_WIDTH = 200;
export var DEFAULT_MIN_WIDTH = 144;
// this size compensation is used to prevent the displacement of the vertical
// scroll exceeding the length of the horizontal scroll, thus preventing the
// horizontal scroll growing indefinitely
export var SIZE_COMPENSATION = 2.1;